import React from 'react'
import { countStops } from './filters/stops/stops'
import moment from 'moment'

const FlightMoreOptions = ({serviceAlternative, selectedURI, select})=>
  <div className="row more-options">
    <div className="col-sm-12 col-lg-13 col-sm-offset-3 col-lg-offset-4 options-list-col">
      <div className="col-wrapper-va">
        <div className="v-align">
          <ul>
            {
              serviceAlternative.get('serviceDetail').entrySeq().map(([uri, sd])=>
              {
                const mCommence = moment( sd.get('commence') )
                const mComplete = moment( sd.get('complete') )
                const duration = moment.duration( sd.get('duration') )
                const stopCount = countStops(sd)

                return <li key={uri}><label className="css-radio">
                  <input type="radio" name={uri} checked={uri===selectedURI}
                    onChange={(e)=>{
                      e.stopPropagation()
                      select(uri)}
                  } /><i></i>
                  <span>
                    {stopCount > 0 &&
                      <span className="stops">
                          {/* TODO: Stop locations*/}
                          <i title="This flight has stops"></i>
                      </span>}
                    <dl className="departure-arrival">
                      <dt>{mCommence.format("DD MMM")}, <time>{mCommence.format("HH:mm")}</time></dt>
                      <dd>{mComplete.format("DD MMM")}, <time>{mComplete.format("HH:mm")}</time></dd>
                    </dl>
                    <dl className="duration-stops">
                      <dt>{Math.floor(duration.asHours())}h{duration.minutes()
                          ? ` ${duration.minutes()}m`
                          : ''}</dt>
                      {stopCount > 0 && <dd>{stopCount} stop{stopCount>1?`s`:''}</dd>}
                    </dl>
                  </span>
                </label></li>
              })
            }
          </ul>
        </div>
      </div>
    </div>
  </div>

export default FlightMoreOptions



// WEBPACK FOOTER //
// ./src/ndc/offer/FlightMoreOptions.js